Object.defineProperty(exports,"__esModule",{value: true});
exports.default=window.GrimoireJS;



//////////////////
// WEBPACK FOOTER
// ./~/grimoirejs/ref/index.js
// module id = 300
// module chunks = 0